import React from 'react';
import { useMediaQueryContext } from '@fourthwall/components';
import { pluralize } from '@fourthwall/utils/dist/string';
import { useCreateProduct } from '@modules/Dashboard/Product/hooks/useCreateProduct';
import { getBonus } from '../../utils';
import { Incentive } from '../Incentive';
export const ProductsIncentive = ({ incentive }) => {
    const { tablet } = useMediaQueryContext();
    const { openCreateProductModal } = useCreateProduct();
    return (React.createElement(Incentive, { type: incentive.type, icon: "\uD83D\uDC55", label: `Create ${incentive.amountToCreate} ${pluralize(incentive.amountToCreate, 'product', 'products')}`, isCompleted: incentive.isCompleted, bonus: getBonus(incentive.bonus), button: {
            label: tablet ? 'Create product' : 'Create',
            onClick: openCreateProductModal,
        } }));
};
